import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cdcjvt8t: FaireBrandEntity = {
  token: "b_cdcjvt8t",
  type: "brand",
  name: "Earth Harbor Naturals",
  avatarUrl:
    "https://cdn.faire.com/fastly/6466290c2103ba303a0b2e976479b76e36e367b2907ac9f92ad06163b0b09200.jpeg",
  bannerUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/84bc5cb37e6c1b437f5c22f316bd7a286da45527a0c8af2f22062e07b7be6e03/1560583035.jpg",
  logoUrl:
    "https://cdn.faire.com/fastly/6466290c2103ba303a0b2e976479b76e36e367b2907ac9f92ad06163b0b09200.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/84bc5cb37e6c1b437f5c22f316bd7a286da45527a0c8af2f22062e07b7be6e03/1560583035.jpg",
  location: "Springville, UT, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 631,
  isTopShop: true,
  isInsider: true,
  description:
    "EARTH HARBOR is a purely natural, ethical skincare line with high-performing ocean nutrients & active botanicals. Here is beauty from the sea — proven, nontoxic & inspiring. Founder, Ali, is a St. Simons Island native, herbalist and health scientist, who created EARTH HARBOR out of her treehouse kitchen. As beach beauty minimalists, we harness the natural power of Ocean & Earth to bring you synthetic-free, sustainable, organic, vegan, cruelty-free products. We proudly partner with 1% For The Planet® to save marine life and are a multi-award-winning, Leaping Bunny, PETA, and Think Dirty® Certified brand. Our sensory, sea-based products offer serenity, glowing skin, and indulgence day in and day out! And as always, they are handcrafted in small batches with love and mermaid vibes. As seen in Whole Foods, Anthropologie, Urban Outfitters, and more. Be sure to visit earthharbor.com! See our important Wholesale Agreement Info and Assets here: https://tinyurl.com/ney6n6cs",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:31.256Z",
    importedBy: "entity-db-cli",
  },
};
